interface SeeNoticeDetailsButtonProps {
    onClick: () => void;
    buttonLabel?: string;
}

export const SeeNoticeDetailsButton = ({
    onClick,
    buttonLabel = 'See Details',
}: SeeNoticeDetailsButtonProps) => (
    <div className="padding__top--small">
        <u
            role="button"
            style={{ cursor: 'pointer' }}
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    onClick();
                }
            }}
        >
            {buttonLabel}
        </u>
    </div>
);
